// Shared between the create flow (index-create.mixin) and the edit flow (SettingsIndexSourceEditor)
// so a Qdrant XML source's field selection is merged/read identically in both.

// Merge the per-source Qdrant field selection into an XML source config, ONLY when non-empty, so the
// Azure path's config stays byte-identical. Returns a new config (does not mutate the input).
export function applyFieldSelection(config, fieldSelection) {
  if (!fieldSelection) return config
  const result = { ...config }
  if (fieldSelection.embed_fields?.length) result.embed_fields = fieldSelection.embed_fields
  if (fieldSelection.payload_fields && Object.keys(fieldSelection.payload_fields).length) {
    result.payload_fields = fieldSelection.payload_fields
  }
  if (fieldSelection.group_key?.length) result.group_key = fieldSelection.group_key
  return result
}

// Read an existing source config back into the field-selection shape the picker component expects.
export function extractFieldSelection(config) {
  return {
    embed_fields: config?.embed_fields || [],
    payload_fields: config?.payload_fields || {},
    group_key: config?.group_key || []
  }
}
